module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABjSURBVHgB7dNBDoAgDETR9qbcRI7iTas1mYSFVdrRHX9VILxdRVZsambtGlR3IYLjA9qkmP8F4ofOoCPmFi5L6C02PKbQRyyLTmGzaAp7Q0tYhFJYgHJYgHb5ohNqhtVa/d4BW4UcGklJVhIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/audio/btn_player_arrowdown.png
// module id = y8Z8
// module chunks = 1